module.exports = __webpack_public_path__ + "img/daily-work-disabled.c4bb89cf.png";